var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campaign-child"},[_c('h2',{staticClass:"campaign-subtitle"},[_vm._v("Покана")]),_c('div',{staticClass:"campaign-content",domProps:{"innerHTML":_vm._s(_vm.campaign.invite)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }